"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidGlueKey = exports.assembleHiveKeyFromObject = exports.extractAllHivePartiionKeys = exports.getHiveTimeKey = exports.getHiveTimeKeyForDatastoreObjectOrType = exports.getHiveKeySuffixForDatastoreObjectOrType = exports.getHivePrefixFromTo = exports.getHivePrefixFromTo_old = exports.getHiveTimeKeyPrefix = exports.hiveTimeKeyToDate = exports.HiveTimeKeysOrderedArr = void 0;
exports.isHiveTimeKeyString = isHiveTimeKeyString;
exports.extractDatePartsFromHiveKey = extractDatePartsFromHiveKey;
exports.hivePrefixGenerator = hivePrefixGenerator;
const core_services_1 = require("@iotv/core-services");
const s3TimeKey_1 = require("./s3TimeKey");
exports.HiveTimeKeysOrderedArr = ['year', 'month', 'day', 'hour', 'min', 'sec', 'ms'];
/**
 * Regular expression for matching HiveTimeKeyString formats.
 * Accepts year, optional month, day, hour, min, sec, ms, all with leading zeros and trailing slash.
 */
const hiveTimeKeyRegex = /year=(\d{4})(?:\/month=(\d{2}))?(?:\/day=(\d{2}))?(?:\/hour=(\d{2}))?(?:\/min=(\d{2}))?(?:\/sec=(\d{2}))?(?:\/ms=(\d{3}))?\/$/;
/**
 * Type guard for HiveTimeKeyString.
 * Checks if a string matches the HiveTimeKeyString format.
 * @param key - The string to check.
 * @returns True if the string matches the HiveTimeKeyString format.
 */
function isHiveTimeKeyString(key) {
    return hiveTimeKeyRegex.test(key);
}
/**
 * Extracts date parts from a HiveTimeKeyString using capture groups.
 * @param hiveKey - The HiveTimeKeyString to extract from.
 * @returns An array of [year, month, day, hour, min, sec, ms] as strings or undefined.
 */
function extractDatePartsFromHiveKey(hiveKey) {
    const match = hiveKey.match(hiveTimeKeyRegex);
    if (!match) {
        throw new Error(`Invalid hiveKey format: ${hiveKey}`);
    }
    // match: [full, year, month?, day?, hour?, min?, sec?, ms?]
    const [, y, m, d, h, min, s, ms] = match;
    return [y, m, d, h, min, s, ms];
}
/**
 * Converts a HiveTimeKeyString to a JavaScript Date object.
 * @param hiveKey - The HiveTimeKeyString to convert.
 * @returns The corresponding Date object.
 */
const hiveTimeKeyToDate = (hiveKey) => {
    if (!isHiveTimeKeyString(hiveKey)) {
        throw new Error(`Invalid hiveKey format: ${hiveKey}`);
    }
    /** hive time key may not have lower order parts, so if they are not present, default to beginning of part period
     * This avoids setting m = '00' etc which shifts everything back when converted to timestamp
     */
    const [y, m = '01', d = '01', h = '00', min = '00', s = '00', ms = '000'] = extractDatePartsFromHiveKey(hiveKey);
    // Build S3PartialTimeKeyElementsType, undefined for missing values
    const s3Key = [y, m, d, h, min, s, ms];
    // Pad to 7 elements if needed
    while (s3Key.length < 7)
        s3Key.push(undefined);
    return (0, s3TimeKey_1.s3TimeKeyToDate)(s3Key);
};
exports.hiveTimeKeyToDate = hiveTimeKeyToDate;
/**
 * Returns a Hive-style time key string (e.g. year=2025/month=09/day=08/...)
 * @param params - Object containing timestamp and S3TimeKeyLevel.
 * @returns HiveTimeKeyString for the given timestamp and level.
 */
const getHiveTimeKeyPrefix = ({ timestamp, s3TimeKeyLevel = s3TimeKey_1.S3TimeKeyLevel.DAY }) => {
    const date = timestamp ? new Date(timestamp) : new Date();
    const [y, m, d, h, min, s, ms] = (0, s3TimeKey_1.getS3TimeKeyElements)(date);
    let key = `year=${y}/`;
    if (s3TimeKeyLevel >= s3TimeKey_1.S3TimeKeyLevel.MONTH)
        key += `month=${m}/`;
    if (s3TimeKeyLevel >= s3TimeKey_1.S3TimeKeyLevel.DAY)
        key += `day=${d}/`;
    if (s3TimeKeyLevel >= s3TimeKey_1.S3TimeKeyLevel.HOUR)
        key += `hour=${h}/`;
    if (s3TimeKeyLevel >= s3TimeKey_1.S3TimeKeyLevel.MINUTE)
        key += `min=${min}/`;
    if (s3TimeKeyLevel >= s3TimeKey_1.S3TimeKeyLevel.SECOND)
        key += `sec=${s}/`;
    if (s3TimeKeyLevel >= s3TimeKey_1.S3TimeKeyLevel.MILLISECOND)
        key += `ms=${ms}/`;
    return key;
};
exports.getHiveTimeKeyPrefix = getHiveTimeKeyPrefix;
/**
 * Returns array of hive time key prefixes that span time range
 * */
const getHivePrefixFromTo_old = (fromTimestamp, toTimestamp, s3TimeKeyLevel) => {
    let start = (0, s3TimeKey_1.getS3TimeKeyElements)(new Date(fromTimestamp));
    let end = (0, s3TimeKey_1.getS3TimeKeyElements)(new Date(toTimestamp));
    const s3Keys = (0, s3TimeKey_1.incrementFromTo)({ start, end, level: s3TimeKeyLevel, inc: 1 });
    return s3Keys.map((v) => (0, exports.getHiveTimeKeyPrefix)({ timestamp: (0, s3TimeKey_1.s3TimeKeyToDate)(v).valueOf(), s3TimeKeyLevel }));
};
exports.getHivePrefixFromTo_old = getHivePrefixFromTo_old;
function* hivePrefixGenerator({ fromTimestampMs, toTimestampMs, s3TimeKeyLevel }) {
    /** start with the base hive time key for the timestamp and level, expressed as a timestampMs */
    let currentHiveTimestampMs = (0, exports.hiveTimeKeyToDate)((0, exports.getHiveTimeKeyPrefix)({ timestamp: fromTimestampMs, s3TimeKeyLevel })).valueOf();
    /** compare to the base hive time key for the toTimestampMs, also expresseds as a timestampMs */
    const endHiveTimestampMs = (0, exports.hiveTimeKeyToDate)((0, exports.getHiveTimeKeyPrefix)({ timestamp: toTimestampMs, s3TimeKeyLevel })).valueOf();
    while (currentHiveTimestampMs <= endHiveTimestampMs) {
        yield (0, exports.getHiveTimeKeyPrefix)({ timestamp: currentHiveTimestampMs, s3TimeKeyLevel });
        currentHiveTimestampMs = (0, s3TimeKey_1.incrementTimestampMsByS3TimeLevel)(currentHiveTimestampMs, s3TimeKeyLevel);
    }
}
const getHivePrefixFromTo = (fromTimestampMs, toTimestampMs, s3TimeKeyLevel) => {
    return Array.from(hivePrefixGenerator({ fromTimestampMs, toTimestampMs, s3TimeKeyLevel }));
};
exports.getHivePrefixFromTo = getHivePrefixFromTo;
/**
 * Returns a Hive key suffix for a datastore object or type.
 * @param params - Object containing type and optional id.
 * @returns Hive key suffix string.
 */
const getHiveKeySuffixForDatastoreObjectOrType = ({ type, id }) => {
    let key = `type=${type}/`;
    if (id) {
        key += `id=${id}/`;
    }
    return key;
};
exports.getHiveKeySuffixForDatastoreObjectOrType = getHiveKeySuffixForDatastoreObjectOrType;
/**
 * Returns a Hive time key for a datastore object or type, combining time prefix and object/type suffix.
 * @param params - Object containing id, type, s3TimeKeyLevel, and timestamp.
 * @returns Hive time key string for the datastore object or type.
 */
const getHiveTimeKeyForDatastoreObjectOrType = ({ id, type, s3TimeKeyLevel, timestamp }) => `${(0, exports.getHiveTimeKeyPrefix)({ s3TimeKeyLevel, timestamp })}${(0, exports.getHiveKeySuffixForDatastoreObjectOrType)({ type, id })}`;
exports.getHiveTimeKeyForDatastoreObjectOrType = getHiveTimeKeyForDatastoreObjectOrType;
/** returns key for hive key object, exludes file prefix such as .parquet */
const getHiveTimeKey = ({ s3TimeKeyLevel, bucketPath, timestamp, type, id, additionPartitionKeys }) => {
    let key = '';
    if (bucketPath)
        key += (0, core_services_1.ensureTrailingSlash)(bucketPath);
    key += `${(0, exports.getHiveTimeKeyForDatastoreObjectOrType)({ type, id, s3TimeKeyLevel, timestamp })}`;
    if (additionPartitionKeys) {
        for (const [k, v] of Object.entries(additionPartitionKeys)) {
            key += `${k}=${v}/`;
        }
    }
    return key;
};
exports.getHiveTimeKey = getHiveTimeKey;
const extractAllHivePartiionKeys = (key) => {
    // Match segments like year=2026, month=01, etc.
    const regex = /(\w+)=([^/]+)/g;
    const res = {};
    let match;
    while ((match = regex.exec(key)) !== null) {
        res[match[1]] = match[2];
    }
    return res;
};
exports.extractAllHivePartiionKeys = extractAllHivePartiionKeys;
const assembleHiveKeyFromObject = (ob) => {
    return Object.entries(ob).map(([k, v]) => `${k}=${v}`).join('/');
};
exports.assembleHiveKeyFromObject = assembleHiveKeyFromObject;
// const isValidGluePartitionPath = /^([a-zA-Z_][a-zA-Z0-9_]*=[^/]+)(\/[a-zA-Z_][a-zA-Z0-9_]*=[^/]+)*$/;
const isValidGluePartitionPath = /^([a-zA-Z_][a-zA-Z0-9_]*=[^/]+)(\/[a-zA-Z_][a-zA-Z0-9_]*=[^/]+)*(\/[\w.-]+\.[\w.-]+)?$/;
/** tests a sub path with key=value entries. This will currently fail a folder prefixed path */
const isValidGlueKey = (s) => typeof s === 'string' && isValidGluePartitionPath.test(s);
exports.isValidGlueKey = isValidGlueKey;
